import React, { useRef } from "react";
import { connect } from "react-redux";
import {
  addToCart,
  addToWishlist,
  addToCompare,
  removeFromWishlist,
  removeFromCompare,
} from "../../../actions";
import classes from "./homeTrendingProducts.module.scss";
import DynamicDots from "../DynamicDots";
import useSliderIndex from "../useSliderIndex";
import { Link } from "react-router-dom";
import Item from "../../algolia_listing/components/item";

const HomeTrendingProducts = (props) => {
  const sliderRef = useRef(null);
  const activeIndex = useSliderIndex(sliderRef);

  const {
    addToCart,
    addToWishlist,
    addToCompare,
    removeFromWishlist,
    wishListItems,
    removeFromCompare,
    compareItems,
    symbol,
    searchResults,
    title = "Trending products",
  } = props;

  if (searchResults.length === 0) return null;

  return (
    <section className={classes.trending_products_section}>
      <div className="custom-container">
        <div className={classes.slider_container}>
          <div className={classes.headingSection}>
            <h2 className={`${classes.title} uk-margin-remove p-0`}>{title}</h2>
            <Link
              className={`${classes.viewall_link} d-none d-md-block`}
              to={`${process.env.PUBLIC_URL}/trending`}
            >
              View All
            </Link>
          </div>
          <div ref={sliderRef} data-uk-slider="autoplay: true; autoplay-interval: 5000; velocity: 1; pause-on-hover: true">
            <div className="uk-position-relative">
              <div className="uk-slider-container uk-light">
                <ul className="uk-slider-items uk-grid uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@l ">
                  {searchResults.map((item, index) => (
                    <div key={index} className={`slide-item`}>
                      <Item
                        key={index}
                        index={index}
                        product={item}
                        symbol={symbol}
                        onAddToCompareClicked={addToCompare}
                        onRemoveFromCompareClicked={removeFromCompare}
                        onAddToWishlistClicked={addToWishlist}
                        onRemoveFromWishlistClicked={removeFromWishlist}
                        onAddToCartClicked={addToCart}
                        wishListedItem={wishListItems}
                        compareItems={compareItems}
                      />
                    </div>
                  ))}
                </ul>
              </div>
              {/* Navigation Arrows */}
              <div className={classes.arrow_container}>
                <a
                  className={`${classes.arrow} uk-position-center-left-out uk-position-small mx-0`}
                  href="#"
                  data-uk-slider-item="previous"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M6.89314 1.69812C6.9768 1.42768 7.26387 1.27626 7.53431 1.35992C7.80476 1.44358 7.95618 1.73065 7.87252 2.00109L7.38283 1.84961L6.89314 1.69812ZM1.74438 8.00064V8.51323H-6.67572e-05L1.46709 7.56953L1.74438 8.00064ZM1.74438 8.00064V7.48805H16.6094V8.00064V8.51323H1.74438V8.00064ZM3.6336 6.78547L3.91089 7.21658L2.02168 8.43175L1.74438 8.00064L1.46709 7.56953L3.35631 6.35437L3.6336 6.78547ZM7.38283 1.84961L7.87252 2.00109C7.20721 4.15179 5.80429 5.99873 3.91089 7.21658L3.6336 6.78547L3.35631 6.35437C5.04668 5.2671 6.29916 3.61821 6.89314 1.69812L7.38283 1.84961Z"
                      fill="#626262"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.21891 11C5.38568 11.8771 6.3135 13.0337 6.91618 14.3633C7.03304 14.6211 7.33708 14.7349 7.59489 14.6182C7.85236 14.5012 7.96637 14.1981 7.84977 13.9404C7.34991 12.8377 6.64985 11.8414 5.78922 11H4.21891Z"
                      fill="#626262"
                    />
                  </svg>
                </a>
                <a
                  className={`${classes.arrow} uk-position-center-right-out uk-position-small mx-0`}
                  href="#"
                  data-uk-slider-item="next"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                  >
                    <path
                      d="M9.71624 1.69812C9.63257 1.42768 9.34551 1.27626 9.07506 1.35992C8.80461 1.44358 8.65319 1.73065 8.73686 2.00109L9.22655 1.84961L9.71624 1.69812ZM14.865 8.00064V8.51323H16.6094L15.1423 7.56953L14.865 8.00064ZM14.865 8.00064V7.48805H0V8.00064V8.51323H14.865V8.00064ZM12.9758 6.78547L12.6985 7.21658L14.5877 8.43175L14.865 8.00064L15.1423 7.56953L13.2531 6.35437L12.9758 6.78547ZM9.22655 1.84961L8.73686 2.00109C9.40217 4.15179 10.8051 5.99873 12.6985 7.21658L12.9758 6.78547L13.2531 6.35437C11.5627 5.2671 10.3102 3.61821 9.71624 1.69812L9.22655 1.84961Z"
                      fill="#626262"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.3905 11C11.2237 11.8771 10.2959 13.0337 9.6932 14.3633C9.57634 14.6211 9.27229 14.7349 9.01449 14.6182C8.75701 14.5012 8.643 14.1981 8.7596 13.9404C9.25946 12.8377 9.95952 11.8414 10.8202 11H12.3905Z"
                      fill="#626262"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <DynamicDots total={searchResults.length} activeIndex={activeIndex} classes={classes} sliderRef={sliderRef} />
          </div>
          <Link
            className={`${classes.viewall_btn} d-md-none`}
            to={`${process.env.PUBLIC_URL}/trending`}
          >
            View All
          </Link>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  wishListItems: state.wishlist.list,
  compareItems: state.compare.items,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps, {
  addToCart,
  addToWishlist,
  removeFromWishlist,
  addToCompare,
  removeFromCompare,
})(HomeTrendingProducts);
